import React, { useEffect, useContext, useState } from 'react';
import '../App.css';

import Jumbotron from 'react-bootstrap/Jumbotron'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Flickity from 'react-flickity-component'

import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'

import "../components/flickity.css";
import { FirebaseContext } from '../firebase'
import { useHistory } from 'react-router-dom';
import FavoriteBtn from '../components/FavoriteBtn';

function Home(props) {

    const { fire, user } = useContext(FirebaseContext)
    const [sequences, setSequences] = useState([])
    const [unpubSequences, setUnpubSequences] = useState([])
    const history = useHistory()

    useEffect(() => {
        getSequences()
    }, [user])

    function getSequences() {
        fire.firestore().collection('sequences').onSnapshot(handleSnapshot)
    }

    function handleSnapshot(snapshot) {

        let s = []
        let us = []

        snapshot.docs.forEach(doc => {
            if (doc.data().published === true) {
                s.push({
                    id: doc.id,
                    ...doc.data()
                })
            } else if (user && doc.data().createdBy === user.uid) {
                us.push({
                    id: doc.id,
                    ...doc.data()
                })
            }
        })
        setSequences(s)
        setUnpubSequences(us)
    }

    const sequenceCards = sequences.map(sequence => {
        return (
            <Card className={"mr-3 mb-3 sequence-card"} key={sequence.id}>
                {/* <div className="position-absolute" style={{top:5, right: 5}}><FavoriteBtn sequence={sequence} /></div> */}
                {sequence.img && <Card.Img onClick={() => { history.push(`/sequence/${sequence.id}`) }} variant="top" src={sequence.img} />}
                <Card.Body onClick={() => { history.push(`/sequence/${sequence.id}`) }}>
                    <h6>{sequence.name ? sequence.name : null}</h6>
                </Card.Body>
            </Card>
        )
    })

    const unpubSequenceCards = unpubSequences.map(sequence => {
        return (
            <Card className={"mr-3 mb-3 sequence-card"} key={sequence.id}>
                {/* <div className="position-absolute" style={{top:5, right: 5}}><FavoriteBtn sequence={sequence} /></div> */}
                {sequence.img && <Card.Img onClick={() => { history.push(`/sequence/${sequence.id}`) }} variant="top" src={sequence.img} />}
                <Card.Body onClick={() => { history.push(`/edit/${sequence.id}`) }}>
                    <h6>{sequence.name ? sequence.name : null}</h6>
                    {/* <Button variant="light">Edit</Button> */}
                </Card.Body>
            </Card>
        )
    })

    return (
        <Container>
            <Row>
                <Col>
                    <div className={"mb-4"}>
                        <Jumbotron>
                            <h1>Welcome!</h1>
                            <p>
                                Sequences is a simple app that lets you find and read articles on various topics related to effective altruism.
                        </p>
                        </Jumbotron>
                        <h4>Latest Sequences</h4>
                        <div className="flex-wrap d-none d-sm-flex">
                            {sequenceCards}
                        </div>
                        <Flickity className="d-block d-sm-none" options={{ wrapAround: false, prevNextButtons: false, cellAlign: "left", pageDots: false }}>
                            {sequenceCards}
                        </Flickity>
                        <br />
                        {unpubSequences.length > 0 && <h4>Your unpublished Sequences</h4>}
                        <div className="flex-wrap d-none d-sm-flex">
                            {unpubSequenceCards}
                        </div>
                        <Flickity className="d-block d-sm-none" options={{ wrapAround: false, prevNextButtons: false, cellAlign: "left", pageDots: false }}>
                            {unpubSequenceCards}
                        </Flickity>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default Home;
